import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'

const FIVE_MINUTES = 1000 * 60 * 5

export type Deliverable = {
    _id: string
    title: string
    type: string
    dueDate: string | null
    isComplete: boolean
    organizationId: string
    strategyId: string
}

type DeliverablesMetricsData = {
    grouping: string
    items: Record<string, Deliverable[]>
}

export const useGetDeliverablesQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const getDeliverables = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const { url, method } = endpoints.getDeliverables

            const response = await callAPI(url + strategyId, method, token)

            return response.data as DeliverablesMetricsData[]
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<DeliverablesMetricsData[]>(['deliverables', strategyId], getDeliverables, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!strategyId,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        retry: 3,
    })
}
